const translations = {
  loading: 'Loading...',
  page_title: 'Contacts',
  sort: 'Sort',
  search_placeholder: 'Search by contact name, email, phone or vehicle make and model',
  contacts_found_n: 'Contacts found: {{n}}',
  contacts_found_0: 'Contacts found: 0',
  no_contacts_search: 'There are no contacts that match your search',
  choose_other: 'Choose other filters and try again',
  no_contacts: 'There are no contacts yet',
  try_again: 'Please try again later',

  please_make_sure: "Please make sure all required fields are filled and it's not a duplicated contact.",
  address_cont: 'Address (Cont)',
  postal_code: 'Postal Code',
  date: 'Date',
  form_URL: 'Form URL',
  message: 'Message',
  conversions: 'Conversions',
  discard_changes: 'Discard changes?',
  all_changes_lost: 'All changes will be lost, this action cannot be undone.',

  id: 'ID',
  fullname: 'Full name',
  email: 'Email',
  phone: 'Phone',
  vehicle_of_interest: 'Vehicle of interest',
  source: 'Source',
  last_interaction: 'Last interaction',
  registered: 'Registered',

  empty_forms: "The customer hasn't filled any form yet",
  contact_updated: 'The contact has been updated successfully.',
  contact_added: 'The contact has been added successfully.',

  male: 'Male',
  female: 'Female',

  full_name: 'Full name',
  first_name: 'First name',
  name: 'Name',
  last_name: 'Last name',
  lastName: 'Last name',
  birthdate: 'Birthdate',

  lead: 'Lead',
  id_number: 'ID number',
  id_type: 'ID type',

  first_name_placeholder: 'Enter the first name',
  last_name_placeholder: 'Enter the last name',
  email_placeholder: 'Enter the email',
  phone_placeholder: 'Enter the phone',
  birthdate_placeholder: 'Enter the birthdate',
  id_number_placeholder: 'Enter the ID number',
  id_type_placeholder: 'Select ID type',
  lead_placeholder: 'Select lead',
};

export default translations;
